import { useIsAfternoon } from 'src/common/useIsAfternoonHook';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { SECRET_MENU_TOOLS, SecretMenuGate } from './secretMenuCatalogue';

export function useSecretMenuTools() {
  const flags = useFlags();
  const { isAfternoon } = useIsAfternoon();

  const passesGate = (gate: SecretMenuGate | undefined) => {
    switch (gate) {
      case undefined:
        return true;
      case 'afternoonOnly':
        return !!isAfternoon;
      case 'botMigrationFlag':
        return flags.flagEnabledBotMigration;
      case 'brandingGenerationFlag':
        return !!isAfternoon && flags.flagEnabledBrandingGeneration;
      case 'onboardingInviteFlag':
        return flags.flagEnabledOnboardingInvite;
      case 'usageMetricsFlag':
        return flags.flagEnabledUsageMetrics;
    }
  };

  const tools = SECRET_MENU_TOOLS.filter(tool => passesGate(tool.gate));

  return {
    tools,
    findAvailableTool: (slug: string) => tools.find(tool => tool.slug === slug),
  };
}
